import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseAccountTypesAdapter = getAdapter({ idFieldName: 'value' });

const warehouseAccountTypesSlice = createSlice({
  name: 'warehouseAccountTypes',
  initialState: warehouseAccountTypesAdapter.getInitialState(),
  reducers: {
    setWarehouseAccountTypes: (state, { payload: { accountTypes } }) => {
      warehouseAccountTypesAdapter.setAll(state, accountTypes);
    },
  },
});

const selectors = warehouseAccountTypesAdapter.getSelectors(({ warehouseAccountTypes }) => warehouseAccountTypes);

export const getWarehouseAccountTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getWarehouseAccountTypes = (state) => getWarehouseAccountTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setWarehouseAccountTypes,
} = warehouseAccountTypesSlice.actions;

export default warehouseAccountTypesSlice.reducer;
